import React from 'react'
import photo from "./photo.png"

function MyProfile() {

    return (
        <div className='mt-6 md:mt-10 w-full flex flex-col md:flex-row gap-4 md:gap-6 items-center justify-center mx-auto'>
            <div className="flex-shrink-0 order-first md:order-none">
                <div className="rounded-2xl overflow-hidden w-[240px] h-[240px] md:w-[280px] md:h-[280px] lg:w-[360px] lg:h-[360px] shadow-lg hover:shadow-2xl transition-all duration-300 bg-gradient-to-br from-violet-600 via-indigo-600 to-purple-700 flex items-end justify-center p-0 m-0 leading-none">
                    <img src={photo} alt="Profile Picture" className="h-full w-auto object-contain m-0 p-0 block" />
                </div>
            </div>
            <div className='flex flex-col items-start justify-center gap-4'>
                <div className='text-left'>
                    <p className='text-gray-500 text-sm font-semibold uppercase tracking-wider'>Sobre a prof.</p>
                    <h2 className='text-2xl md:text-3xl font-bold text-gray-900 mt-2'>13+ anos de experiência</h2>
                </div>
                <p className='text-gray-700 text-base md:text-lg leading-relaxed max-w-md text-left'>
                    Especializada em aulas online para adultos com foco em fluência conversacional. Experiência em escolas de idiomas, aulas in-company e metodologia prática com resultados comprovados.
                </p>
                <div className='flex gap-6 md:gap-8 pt-2'>
                    <div className='text-left'>
                        <p className='text-2xl md:text-3xl font-bold text-gray-900'>5,000+</p>
                        <p className='text-gray-600 text-sm font-medium'>alunos</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MyProfile